module.exports = __webpack_public_path__ + "static/media/calendar.72317b96.svg";